module.exports = __webpack_public_path__ + "static/media/SWANTANCA_MENU-normal.27a4ac43.png";